import { createContext } from 'react';
import { IParser } from '../../../shared/parsers/factory';

export type ParserContextValue = {
  parser: IParser<any>;
};

export const ParserContext = createContext<ParserContextValue>({ parser: {} as IParser<any> });
